/** Static zone positions for the graph layout, inspired by the OoT map. */
export interface ZonePosition {
  x: number;
  y: number;
  width: number;
  height: number;
  label: string;
}

export const ZONE_POSITIONS: Record<string, ZonePosition> = {
  // Forest region (top-left)
  KF:        { x: 0,    y: 0,    width: 220, height: 200, label: 'Kokiri Forest' },
  LW:        { x: 260,  y: 0,    width: 220, height: 200, label: 'Lost Woods' },
  SFM:       { x: 260,  y: 240,  width: 220, height: 200, label: 'Sacred Forest Meadow' },

  // Hyrule center
  HF:        { x: 540,  y: 120,  width: 260, height: 280, label: 'Hyrule Field' },
  MKT:       { x: 540,  y: 440,  width: 260, height: 280, label: 'Market / Castle' },
  HC:        { x: 540,  y: 760,  width: 220, height: 140, label: 'Hyrule Castle' },
  OGC:       { x: 540,  y: 940,  width: 220, height: 140, label: 'Outside Ganons Castle' },
  LLR:       { x: 840,  y: 120,  width: 220, height: 180, label: 'Lon Lon Ranch' },

  // Kakariko / Graveyard (right)
  KAK:       { x: 1100, y: 0,    width: 260, height: 280, label: 'Kakariko Village' },
  GY:        { x: 1100, y: 320,  width: 220, height: 220, label: 'Graveyard' },

  // Death Mountain (top-right)
  DMT:       { x: 1400, y: 0,    width: 220, height: 220, label: 'Death Mountain Trail' },
  GC:        { x: 1660, y: 0,    width: 220, height: 180, label: 'Goron City' },
  DMC:       { x: 1660, y: 220,  width: 220, height: 200, label: 'Death Mountain Crater' },

  // Zora (right-center)
  ZR:        { x: 1100, y: 580,  width: 220, height: 180, label: 'Zora River' },
  ZD:        { x: 1400, y: 480,  width: 220, height: 180, label: 'Zoras Domain' },
  ZF:        { x: 1660, y: 460,  width: 220, height: 200, label: 'Zoras Fountain' },
  LH:        { x: 840,  y: 340,  width: 220, height: 200, label: 'Lake Hylia' },

  // Desert (bottom-left)
  GV:        { x: 0,    y: 480,  width: 220, height: 180, label: 'Gerudo Valley' },
  GF:        { x: 0,    y: 700,  width: 220, height: 180, label: 'Gerudo Fortress' },
  Wasteland: { x: 0,    y: 920,  width: 220, height: 140, label: 'Haunted Wasteland' },
  DCol:      { x: 260,  y: 920,  width: 220, height: 180, label: 'Desert Colossus' },
};
